import React from 'react';

import { Grid, Typography } from '@mui/material';

import Answer from './Answer';
import Stimulus from './Stimulus';

export default function MicroItem({ index }) {
    const part = Math.floor(index / 4) + 1;
    const subIndex = index % 4;
    const isDistractor = subIndex === 3;

    return (
        <>
            <Grid item xs={12}>
                <Typography>
                    Phase {part}{' '}
                    {isDistractor ? 'Distractor' : `Line ${subIndex + 1}`}
                </Typography>
            </Grid>
            {/* Stimulus */}
            {!isDistractor && (
                <Grid item xs={12}>
                    <Stimulus index={index} />
                </Grid>
            )}

            <Grid item xs={12}>
                <Answer index={index} />
            </Grid>

            <Grid item xs={12}>
                <Typography variant='caption'>
                    Use a wider screen to edit display order.
                </Typography>
            </Grid>
        </>
    );
}